import BottomNavigation from '@mui/material/BottomNavigation'
import BottomNavigationAction from '@mui/material/BottomNavigationAction'
import Box from '@mui/material/Box'
import HomeIcon from '@mui/icons-material/Home'
import ExploreIcon from '@mui/icons-material/Explore'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import PersonIcon from '@mui/icons-material/Person'
import { useLocation, useNavigate } from 'react-router'
import getActiveIndex from './getActiveIndex'

const navItems = [
  { label: 'Home', icon: <HomeIcon />, route: '/home' },
  { label: 'Dives', icon: <ExploreIcon />, route: '/dives' },
  { label: 'Create', icon: <AddCircleIcon />, route: '/dives/create' },
  { label: 'Account', icon: <PersonIcon />, route: '/account' }
]

const BottomNavBar = () => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const activeIndex = getActiveIndex(pathname)

  return (
    <Box
      component='nav'
      aria-label='Main navigation'
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        paddingBottom: 'env(safe-area-inset-bottom)',
        zIndex: 1100
      }}
    >
      <BottomNavigation
        value={activeIndex ?? false}
        onChange={(_event, newValue: number) => {
          navigate(navItems[newValue].route)
        }}
        showLabels
      >
        {navItems.map((item, index) => (
          <BottomNavigationAction
            key={item.label}
            label={item.label}
            icon={item.icon}
            aria-current={activeIndex === index ? 'page' : undefined}
          />
        ))}
      </BottomNavigation>
    </Box>
  )
}

export default BottomNavBar
